import { call, put, takeEvery } from 'redux-saga/effects';
import { SalesAdminActionKeys, SaveSourceOfPower } from '..';
import { IApiExecuteRespone } from '../../apiInterfaces';
import { ISourceOfPower, lookupActionCreators } from '../../lookups';
import { showFailedRequestDialog } from '../../sagaUtils';
import { uiActionCreators } from '../../ui';
import { saveSourceOfPower } from '../salesAdminApi';

function* saveSourceOfPowerSaga(action: SaveSourceOfPower) {
  yield put(uiActionCreators.showSpinnerDialog());

  const response: IApiExecuteRespone<ISourceOfPower> = yield call(saveSourceOfPower, action.payload);

  if (response.requestFailed) {
    yield showFailedRequestDialog(response);
  } else if (response.value) {
    yield put(lookupActionCreators.setLookups({ partial: true, payload: { sourcesOfPower: [response.value] } }));
  }

  yield put(uiActionCreators.hideSpinnerDialog());
}

export function* watchSaveSourceOfPower() {
  yield takeEvery(SalesAdminActionKeys.SAVE_SOURCE_OF_POWER, saveSourceOfPowerSaga);
}
